import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';

export type OfferRequestsEmptyStateProps = {
    title: string;
    hint: string;
};

export function OfferRequestsEmptyState({ title, hint }: OfferRequestsEmptyStateProps): ReactElement {
    return (
        <Stack role="status" alignItems="center" justifyContent="center" sx={{ py: 8, color: 'text.secondary' }}>
            <Typography variant="body1">{title}</Typography>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
                {hint}
            </Typography>
        </Stack>
    );
}
